import '@babel/polyfill';
import '../../utils/customEvent';
import './pdp.less';
import Axios from 'axios';
import PriceBlock from './price-section/price-section';
import Sticky, { STICK_POSITION_BOTTOM } from '../../common/components/sticky/sticky';
import * as Breadcrumbs from '../../common/components/breadcrumbs/breadcrumbs';
import * as PriceSpider from './price-spider/price-spider';
import * as ShareButton from './share_button/share_button';
import { Favorites } from './add-to-favourites/add-to-favourites';
import * as TechnicalSpecification from './details-tabs/tabs/technical_specification/technical_specification';

import '../../images-svg-sprite/attention_rounded.svg';
import '../../images-svg-sprite/minus.svg';
import '../../images-svg-sprite/plus.svg';
import '../../images-svg-sprite/pin.svg';
import '../../images-svg-sprite/phone_ic.svg';
import '../../images-svg-sprite/pdf_ic.svg';
import '../../images-svg-sprite/soft_ic.svg';
import '../../images-svg-sprite/battery_ic.svg';
import '../../images-svg-sprite/lec_ic.svg';
import '../../images-svg-sprite/faq_ic.svg';
import '../../images-svg-sprite/pr_ic.svg';
import '../../images-svg-sprite/external_link.svg';
import '../../images-svg-sprite/chm_ic.svg';
import '../../images-svg-sprite/cad_ic.svg';
import '../../images-svg-sprite/print.svg';
import '../../images-svg-sprite/arrow_up_white.svg';
import '../../images-svg-sprite/arrow_up_grey.svg';
import '../../images-svg-sprite/white-glove.svg';
import '../../images-svg-sprite/green_premium.svg';
import '../../images-svg-sprite/rohs.svg';
import '../../images-svg-sprite/energy_star.svg';
import '../../images-svg-sprite/universal_ic.svg';
import '../../images-svg-sprite/ups_ic.svg';
import '../../images-svg-sprite/information-white.svg';
import '../../images-svg-sprite/information-gray.svg';
import '../../images-svg-sprite/download.svg';
import '../../images-svg-sprite/check.svg';
import '../../images-svg-sprite/tooltip.svg';
import '../../images-svg-sprite/tooltip_howtobuy.svg';
import '../../images-svg-sprite/dat_ic.svg';
import '../../images-svg-sprite/doc_ic.svg';
import '../../images-svg-sprite/xlc_ic.svg';
import '../../images-svg-sprite/crtf_ic.svg';
import '../../images-svg-sprite/zip_ic.svg';
import '../../images-svg-sprite/Product_Selector.svg';
import '../../images-svg-sprite/1.svg';
import '../../images-svg-sprite/2.svg';
import '../../images-svg-sprite/q-icon.svg';
import '../../images-svg-sprite/q-icon-select.svg';
import '../../images-svg-sprite/close.svg';
import '../../images-svg-sprite/info.svg';
import {
    onSwitchToDesktop,
    onSwitchFromDesktop,
    firstResizeListen,
} from '../../utils/resizeObserver';
import { getProductData } from './utils/data';
import { appendShowMore, removeShowMore } from '../../common/components/show-more/show-more';
import { onDomChange } from '../../utils/onDomChange';
import { lazyLoadImages } from './lazy-load-images';
import {
    duplicateLabelsForStickyHeader,
    duplicatePartNumberForStickyHeader,
} from './product-description/product-description';
import { resetScrollOnRefresh } from './utils/scrollTopOnRefresh';
import { renderChips } from './chips-links/chips-links';
import { setPreloader } from '../../utils/setPreloader';
import { preventLink } from '../../utils/preventLink';
import { downloadHandler, makePopup } from './download-popup/download-popup';
import { makeUrl } from '../../utils/makeUrl';
import { renderBlock, substituteBlock } from './asyncPriceBlock/components';
import {
    ADD_TO_CART,
    PURCHASE_CD,
    DISCONTINUED,
    NOT_AVAILABLE_IN_SITE,
} from './asyncPriceBlock/availabilityOptions';

import '../../../analytics';

// if (process.env.NODE_ENV === 'development') {
//     import('../../utils/injectMenu').then(({ init }) => init());
// }

const linksToDisabled = Array.from(
    document.querySelectorAll(
        '[href="#"], [href="#software"], [data-item-name="Compatible-UPS-Models"]'
    )
);
linksToDisabled.forEach(item => item.addEventListener('click', preventLink));

window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('apc-pdp');
});

const loadAsyncModules = async () => {
    const loadedModules = [
        import(/* webpackChunkName: "pdp_carousel" */ './product-description/app-carousel'),
        import(/* webpackChunkName: "pdp_tabs" */ './details-tabs/details-tabs'),
    ];
    const [{ default: AppCarousel }, { Tab }] = await Promise.all(loadedModules);
    AppCarousel();
    const tabsComponent = Tab.init({
        tabsList: '.pd-tabs__list',
        tabs: '.pd-tabs__content',
    });

    TechnicalSpecification.init({
        callbackAfterPrint() {
            tabsComponent.selectTab('technical_specification', false);
            tabsComponent.switcher.scroll(
                'technical_specification',
                document.querySelector('#technical_specification'),
                0
            );
        },
    });

    const [TemplateListModule, tabs] = await Promise.all([
        import(/* webpackChunkName: "pdp_options" */ './details-tabs/tabs/templateListModule/templateListModule'),
        tabsComponent.loadContent(),
    ]);
    let ratingTabCallback = null;
    let tabsReady = false;
    if (tabs.has('ratings_and_reviews')) {
        const bvElement = document.getElementById('bvReviews');
        const rootElement = document.getElementById('ratings_and_reviews');
        if (document.getElementById('BVRRContainer')) {
            ratingTabCallback = () => {
                bvElement.parentElement.className = '';
                appendShowMore([rootElement]);
            };
        } else {
            onDomChange(bvElement, (observer, mutations) => {
                const isAppendedBV = mutations.some(({ target }) => target.id === 'BVRRContainer');
                if (!isAppendedBV) return;

                ratingTabCallback = () => {
                    bvElement.parentElement.className = '';
                    appendShowMore([rootElement]);
                };
                if (tabsReady) {
                    ratingTabCallback();
                    ratingTabCallback = null;
                }
                observer.disconnect();
                window.bvCallback = BV => {
                    BV.reviews.on('show', () => {
                        setTimeout(() => {
                            const tabContent = rootElement.querySelector('.tab-content');
                            tabContent.scrollTop = 0;
                            tabsComponent.selectTab('ratings_and_reviews', false);
                            tabsComponent.switcher.scroll('ratings_and_reviews', tabContent, 0);
                            removeShowMore(tabContent);
                        }, 0);
                        return false;
                    });
                };
            });
        }
    }

    if (tabs.has('software_and_firmware')) {
        import('./details-tabs/tabs/software_and_firmware/software_and_firmware').then(module => {
            module.init();
        });
    }

    const productData = getProductData();
    const optionsData = await TemplateListModule.loadOptionsForSku(
        productData.skuId,
        productData.siteId
    );
    const { service, options } = optionsData.reduce(
        (obj, current) => {
            if (current.service) {
                obj.service.push(current);
            } else {
                obj.options.push(current);
            }
            return obj;
        },
        { service: [], options: [] }
    );
    const optionTab = document.getElementById('options');
    const serviceTab = document.getElementById('service');
    let optionsLoad = Promise.resolve();
    if (options.length) {
        optionsLoad = TemplateListModule.default(options, optionTab, () => {
            tabsComponent.selectTab('options');
        });
    } else {
        TemplateListModule.removeTab(optionTab);
    }
    if (service.length) {
        TemplateListModule.default(service, serviceTab, () => {
            tabsComponent.selectTab('service');
        });
    } else {
        TemplateListModule.removeTab(serviceTab);
    }
    tabsComponent.showTabs({
        onEnd: elements => {
            appendShowMore(
                elements.filter(
                    element =>
                        element.id !== 'ratings_and_reviews' && element.id !== 'documentation'
                )
            );
            tabsReady = true;
            if (ratingTabCallback) {
                ratingTabCallback();
            }
        },
    });
    // Other events listening

    const handlerForLinks = (dom, handleClick) => {
        if (dom) {
            dom.classList.remove('is-loading');
            dom.addEventListener(
                'click',
                (dom.fn = e => {
                    e.preventDefault();
                    handleClick();
                })
            );
        }
    };
    const softwareLink = document.querySelector('.quick-product-links__item_software.is-loading');
    const documentationLink = document.querySelector(
        '.quick-product-links__item_documentation.is-loading'
    );
    handlerForLinks(softwareLink, () => tabsComponent.selectTab('software_and_firmware'));
    handlerForLinks(documentationLink, () => tabsComponent.selectTab('documentation'));

    linksToDisabled.forEach(item => item.removeEventListener('click', preventLink));
    Array.from(
        document.querySelector('.quick-product-links__list').querySelectorAll('.spinner-loader')
    ).forEach(preloader => {
        setPreloader(preloader.parentElement).destroy();
    });

    const compatibleUpsModelsLink = document.querySelector(
        '.quick-product-links__item[data-item-name="Compatible-UPS-Models"]'
    );

    if (compatibleUpsModelsLink) {
        import('./compatible-ups-popup/compatible-ups-popup').then(module => {
            handlerForLinks(compatibleUpsModelsLink, () =>
                module.compatibleUpsPopup(productData.skuId, productData.siteId)
            );
        });
    }

    const viewProductOverviewLink = document.querySelector(
        '.product-description__custom-solution-text'
    );

    if (viewProductOverviewLink) {
        viewProductOverviewLink.addEventListener('click', event => {
            event.preventDefault();
            tabsComponent.selectTab('overview');
        });
    }

    tabsComponent.initializeHorizontalScroll();

    const RescentlyViewedCarousel = await Promise.resolve(
        import(/* webpackChunkName: "pdp_rescentlyViewedCarousel" */ './recently-viewed-carousel/recently-viewed-carousel')
    );
    const rootElement = document.querySelector('.recently-viewed-carousel');
    RescentlyViewedCarousel.init({
        productId: productData.productId,
        siteId: productData.siteId,
        carouselTitle: productData.recentlyViewedCarouselTitle,
        rootElement,
    });

    lazyLoadImages('lazy-load-image');

    return {
        optionsLoad,
        toDoLater: () => tabsComponent.goToInitial(),
    };
};

/**
 * Append Sticky button behavior
 * @param {string} id
 * @param {string} stickyAdditionalClass
 */
const appendStickyBehaviorToElement = (
    idOrElement,
    stickyAdditionalClass,
    stickTo = STICK_POSITION_BOTTOM
) => {
    const element =
        idOrElement instanceof Element ? idOrElement : document.getElementById(idOrElement);
    if (element) {
        const btnSticked = new Sticky(element, {
            stickTo,
            stickyAdditionalClass,
            stickyCondition: config =>
                (config.bottom > config.offsetBottom - config.offsetTop || config.bottom < 64) &&
                config.innerHeight > config.innerWidth,
        });

        onSwitchToDesktop(btnSticked.destroy);
        onSwitchFromDesktop(btnSticked.init);
        btnSticked.init();
    }
};
window.addEventListener('load', () => {
    resetScrollOnRefresh();

    Breadcrumbs.init();

    const loadModules = loadAsyncModules();

    const priceSpider = document.querySelector('.product-description__price-section_wrapper');
    const priceReady = new Promise(resolve => {
        if (!document.querySelector('.ps-widget__block')) {
            resolve();
            return;
        }
        if (!NodeList.forEach) {
            // to fix IE issue with forEach
            NodeList.prototype.forEach = function forEach(func) {
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < this.length; i++) {
                    func(this[i], i, this);
                }
            };
        }
        const observerPrice = new MutationObserver(mut => {
            const preloader = priceSpider.querySelector('.ps_widget__preloader');
            if (!preloader || preloader.classList.contains('ps_widget__preloader_hidden')) {
                // eslint-disable-next-line
                closeTask();
                return;
            }
            mut.forEach(item => {
                item.removedNodes.forEach(change => {
                    if (change.classList && change.classList.contains('ps-widget__block')) {
                        // eslint-disable-next-line
                        closeTask();
                    }
                });
            });
        });
        const closeTask = () => {
            observerPrice.disconnect();
            resolve();
        };
        const config = { subtree: true, childList: true };
        observerPrice.observe(priceSpider, config);
    });
    loadModules.then(result => {
        result.optionsLoad.then(() => {
            const sticked = document.querySelector('.product-description-block__sticked');
            if (
                sticked &&
                sticked.querySelector('.product-description__price-section-partners-wrapper')
            ) {
                result.toDoLater();
            } else {
                priceReady.then(() => {
                    result.toDoLater();
                });
            }
        });
    });

    const productData = getProductData();
    const domChips = document.querySelector('.product-description__chips-links');
    if (domChips) {
        renderChips({
            skuId: productData.skuId,
            dom: domChips,
            contextPath: productData.contextPath,
        });
    }

    // Initialization of low priority modules
    PriceSpider.init();
    ShareButton.init();

    firstResizeListen();
    resetScrollOnRefresh();

    const viewProductOverviewLink = document.querySelector(
        '.product-description__custom-solution-text'
    );

    if (viewProductOverviewLink) {
        viewProductOverviewLink.addEventListener('click', event => {
            event.preventDefault();

            
        });
    }

    function convertObject(sku, obj) {
        const data = {};
        // eslint-disable-next-line
        for (let key in obj) {
            data[key] = obj[key][sku] !== undefined ? obj[key][sku] : obj[key];
        }
        return data;
    }

    const [, skuId] = productData.skuId.split('SKU-');

    if (productData.requestPriceAvailabilityInfo === 'true') {
        Axios.get(
            makeUrl(
                `/rest/model/schneider/catalog/availability/rest/ProductAvailabilityActor/pdpProductAvailabilityInfo?partNumbersList=${skuId}&pushSite=${
                    productData.siteId
                }`
            )
        ).then(res => {
            const data = convertObject(skuId, res.data);
            document.querySelector('.async-block-wrapper').innerHTML = renderBlock({
                ...data,
                ...productData,
            });
            if (data.substitution && data.substitution.showButton) {
                document
                    .querySelector('.product-description__price-section_wrapper')
                    .insertAdjacentHTML(
                        'beforeend',
                        substituteBlock({
                            ...data,
                            ...productData,
                        })
                    );
            }
            const downloadStock = data.downloads && data.downloads.length;
            const hasNoPrice =
                data.availability === DISCONTINUED ||
                data.availability === NOT_AVAILABLE_IN_SITE ||
                downloadStock;
            const prices = hasNoPrice ? {} : data.prices || {};
            const {
                activePriceNoTax: taxFree = '',
                activePriceValue: taxIncluded = '',
                previousPriceValue: productDiscount,
            } = prices;
            Object.assign(priceSpider.dataset, {
                taxFree,
                taxIncluded,
                productDiscount: productDiscount ? 1 : 0,
                productStock:
                    data.availability === ADD_TO_CART ||
                    data.availability === PURCHASE_CD ||
                    downloadStock
                        ? '1'
                        : '0',
            });

            Favorites.init('add_to_favourites');

            const priceInAddToFav = document.querySelector('.add-to-fav__price');
            if (priceInAddToFav) {
                priceInAddToFav.innerHTML = data.prices ? data.prices.activePrice : '';
            }
            const download = document.querySelector('.sticky-wrapper .has-option-download');
            if (download) {
                download.addEventListener('click', () => {
                    const dataForPopup = {
                        downloadLinks: data.downloads,
                        pic: document.querySelector('#DataDisplay').src,
                        partnumber: skuId,
                        name: document.querySelector('.product-description-title').innerHTML,
                        translations: {
                            'software.download.fileTitle': productData.fileTitle,
                            'software.download.fileType': productData.fileType,
                            'software.download.fileSize': productData.fileSize,
                            'software.updatedOn': productData.updatedOn,
                            'finder.software.availableVersions': productData.availableVersions,
                            'pdp.label.download': productData.msgDownloadLabel,
                        },
                    };
                    makePopup(dataForPopup);
                });
            }

            PriceBlock.init();
            duplicateLabelsForStickyHeader();

            appendStickyBehaviorToElement(
                'add-to-cart__background',
                'add-to-cart_sticked',
                STICK_POSITION_BOTTOM
            );
            appendStickyBehaviorToElement(
                'call-for-availability',
                'call-for-availability_sticked',
                STICK_POSITION_BOTTOM
            );

            appendStickyBehaviorToElement(
                'substitute_btn__background',
                'substitute_btn__sticked',
                STICK_POSITION_BOTTOM
            );

            if (!document.querySelector('#download_btn__background')) {
                appendStickyBehaviorToElement(
                    document.querySelector('.async-block-wrapper .how-to-buy'),
                    'how-to-buy_sticked',
                    STICK_POSITION_BOTTOM
                );
            }
            appendStickyBehaviorToElement(
                'download_btn__background',
                'has-option-download',
                STICK_POSITION_BOTTOM
            );
        });
    }

    duplicatePartNumberForStickyHeader();

    const downloadButtons = Array.from(document.querySelectorAll('.has-option-download'));
    downloadButtons.forEach(item => {
        item.addEventListener('click', downloadHandler);
    });
});
